import { GetUserReviewApplicationRequest } from 'core/models/users/review/get-user-review-application.model';
import { UserV1BaseServerRepo } from 'core/repository/base-server/v1/user.repo';
import { WalletType } from 'core/models/users/wallet/wallet-address.model';
import { SocialNetworkType } from 'core/models/users/socials/user-social.model';
import { FC, ReactNode, useEffect, useState } from 'react';
import BPSpinner from 'components/BionicUI/loading/BPSpinner';
import { InvestmentCapType } from 'core/models/users/profile/user-profile.model';
import { usePrivy } from '@privy-io/react-auth';
import BPContainer from 'components/BionicUI/container/BPContainer';
import BPButton from 'components/BionicUI/button/BPButton';

class ReviewApplication {
  email?: string = '';
  name?: string = '';
  country?: string = '';
  twitter?: string | null = '';
  mainWallet?: string = '';
  additionalWallets?: string[] = [];
  linkedin?: string = '';
  investmentCap?: InvestmentCapType;
}

const DisplayApplicationData: FC<{ handleSubmit: () => {} }> = ({
  handleSubmit,
}) => {
  const [reviewApplication, setReviewApplication] =
    useState<ReviewApplication>();
  const { user } = usePrivy();

  useEffect(() => {
    async function fetchReviewApplication() {
      const request: GetUserReviewApplicationRequest = {};
      const response = await new UserV1BaseServerRepo().reviewApplication(
        request
      );

      setReviewApplication({
        // email: response?.emailAddress?.email,
        name: response?.profile?.displayName,
        country: response?.profile?.address?.country,
        twitter: user?.twitter?.username,
        mainWallet: response?.walletAddresses?.find(
          (wallet) => wallet.walletType === WalletType.MAIN
        )?.address,
        additionalWallets: response?.walletAddresses
          ?.filter((wallet) => wallet.walletType === WalletType.ADDITIONAL)
          .map((wallet) => wallet.address),
        linkedin: response?.profile?.socialLinks.find(
          (link) => link.socialNetwork === SocialNetworkType.LINKEDIN
        )?.url,
        investmentCap: response?.profile?.investmentCap,
      });
    }
    fetchReviewApplication();
  }, [user]);

  return (
    <>
      <div className="grid relative gap-5">
        <h1 className="text-[18px]">
          Here's a summary of the details you've entered.
        </h1>
        <div className="grid grid-cols-[1fr_auto] gap-y-2 justify-between text-[16px]">
          <Section>Create your account</Section>
          {/* <Item label="Email" value={reviewApplication?.email || '-'} /> */}
          <Item label="Name" value={reviewApplication?.name || '-'} />

          <Section>Where are you from?</Section>
          <Item
            label="Country of residence:"
            value={reviewApplication?.country || '-'}
          />

          <Section>Connect to X.com</Section>
          <Item
            label="Username"
            value={`@${reviewApplication?.twitter || '-'}`}
          />

          {/* <Section>
            Connect wallet
            {reviewApplication?.additionalWallets?.length ? 's' : ''}
          </Section>
          <Item
            label="Connected wallet"
            value={reviewApplication?.mainWallet || '-'}
          /> */}
        </div>
        <BPContainer twWidth="w-auto md:w-[644px] justify-normal">
          <BPButton state="primary" onClick={handleSubmit}>
            Submit
          </BPButton>
        </BPContainer>
      </div>
      {!reviewApplication && (
        <div className="grid absolute top-0 left-0 w-full h-full backdrop-blur-md bg-black place-content-center z-30">
          <BPSpinner />
        </div>
      )}
    </>
  );
};

const Section: FC<{ children: ReactNode }> = ({ children }) => (
  <div className="pt-5 col-span-2">{children}</div>
);
const Item: FC<{ label: string; value: string }> = ({ label, value }) => (
  <>
    <div className="text-bionic-muted">{label}</div>
    <div className="text-right">{value}</div>
  </>
);

export default DisplayApplicationData;
